import { livingArrangementsTypes, employmentTypes } from "../../../constants";
import criteria from "../../../utils/criteria";

const { PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS } = livingArrangementsTypes;

const { SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL, BENEFITS } = employmentTypes;

const {
  assetType,
  loanAmountBetween,
  employmentType,
  timeOfEmploymentGreaterThan,
  livingArrangements,
  creditScoreBetween,
  termIsLessThanOrEqualTo,
} = criteria;

const silver = [
  {
    name: "Silver - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(5000, 6000),

      termIsLessThanOrEqualTo(24),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(6000, 8000),

      termIsLessThanOrEqualTo(36),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(8000, 15000),

      termIsLessThanOrEqualTo(48),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(15000, 30000),

      termIsLessThanOrEqualTo(60),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(30000, 55000),

      termIsLessThanOrEqualTo(72),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver Micro - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(2000, 6000),

      termIsLessThanOrEqualTo(24),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver Micro - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(6000, 8000),

      termIsLessThanOrEqualTo(36),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },

  {
    name: "Silver Micro - New/Demo",
    rate: 19.95,
    productType: "Adverse",
    info: ["Min score>500 allows for 2 or less defaults and ex-bankrupts more than 2 years old"],
    criteria: [
      loanAmountBetween(8000, 12000),

      termIsLessThanOrEqualTo(48),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),
      creditScoreBetween(500, 550),
    ],
  },
];
export default silver;
